<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex class="mt-12" xs12 sm8 md8 lg8 >
            <v-card v-if="orderData" >
              <v-card-title>
                <v-avatar
                    class="mt-2"
                    size="72px"
                    tile

                >
                  <img
                      alt="Avatar"
                      :src="orderData.logo"
                      style="border-radius: 10%;"
                  >
                </v-avatar>
              </v-card-title>
              <v-card-title class="text-h5">{{orderData.listingName}}</v-card-title>
              <v-card-subtitle class="pt-1">
                <div>Order# {{orderData.invoiceNumber}}</div>
                <div>{{orderData.dateCreated}}</div>
              </v-card-subtitle>
              <v-card-text v-if="orderData">

                <v-divider></v-divider>
                <v-list v-if="orderData.contactPhoneNumber">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title v-if="orderData.companyName">{{orderData.companyName}}</v-list-item-title>
                      <v-list-item-title v-if="orderData.contactName">{{orderData.contactName}}</v-list-item-title>
                      <v-list-item-title v-if="orderData.contactAddress">{{orderData.contactAddress}}</v-list-item-title>
                      <v-list-item-title v-if="orderData.contactPhoneNumber">{{orderData.contactPhoneNumber}}</v-list-item-title>
                      <v-list-item-title v-if="orderData.contactEmail">{{orderData.contactEmail}}</v-list-item-title>

                    </v-list-item-content>
                  </v-list-item>

                </v-list>
                <v-divider v-if="orderData.contactPhoneNumber"></v-divider>

                <v-list>
                  <v-list-item>
                    <v-list-item-title class="subtitle-1">
                      <div>Date: {{momentDate(orderData.dateOfService)}}</div>
                      <div>Time: {{momentTime(orderData.time)}}</div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
                <v-divider></v-divider>
              </v-card-text>

              <v-card-text v-if="orderData.locations">
                <div v-if="orderData.locations.length < 2" class="subtitle-1">Location</div>
                <div v-if="orderData.locations.length > 1" class="subtitle-1">Locations</div>
                <v-list v-if="orderData.locations.length!== 0">
                  <v-list-item v-for="location in orderData.locations"
                               :key="location.created">
                    <v-list-item-content >
                      <v-list-item-title>{{location.name}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>

              <v-card-text v-if="orderData.message">
                <v-divider></v-divider>
                <div class="subtitle-1 mt-4">Message</div>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <div>{{orderData.message}}</div>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

              </v-card-text>
              <v-card-text  v-if="orderData.lineItems">
                <div class="subtitle-1 pb-4">Order Summary</div>
                <v-simple-table
                    fixed-header
                >
                  <template >
                    <thead>
                    <tr>
                      <th class="text-left">
                        Item
                      </th>
                      <th>
                        Qty
                      </th>
                      <th>
                        Cost
                      </th>
                      <th>
                        Total
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="item in orderData.lineItems"
                        :key="item.title"
                    >
                      <td>{{ item.title }}</td>
                      <td>{{ Number(item.qty).toFixed(2) }}</td>
                      <td>{{ Number(item.unitPrice).toFixed(2) }}</td>
                      <td>{{ Number(item.totalPrice).toFixed(2) }}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <div class="subtitle-1"> Total Cost: ${{orderData.totalCost}}</div>
              </v-card-text>

              <v-card-text>
                <v-divider></v-divider>
                <div class="subtitle-1 mt-4">Payments</div>
                <v-simple-table v-if="orderData">
                  <template v-slot:default>
                    <tbody>
                    <tr
                        v-for="item in orderData.payments"
                        :key="item.created"
                    >
                      <td>{{ item.splitTitle }}</td>
                      <td>${{item.splitAmount}}</td>
                      <td v-if="item.status"> {{item.status}}</td>
                    </tr>
                    <tr>
                      <td>Remaining Balance</td>
                      <td>$ {{orderData.balanceRemaining}}</td>
                      <td v-if="orderData.remainingBalanceStatus">{{orderData.remainingBalanceStatus}}</td>
                    </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
              <v-card-text class="mb-4" v-if="!orderData.paymentNotRequired">
                <div class="headline mb-4" >Due Now: $ {{orderData.dueNow}}</div>
                <v-row justify="center">
                  <v-expansion-panels  v-if="orderData.paymentMethods.length > 1" multiple inset>
                    <v-expansion-panel
                        v-for="payment in orderData.paymentMethods"
                        :key="payment.id"
                    >
                      <v-expansion-panel-header>
                        <v-img contain :src="payment.thumbNailImg" max-height="75" max-width="150"></v-img>{{payment.paymentMethod}}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-img contain :src="payment.imageUrl" max-height="250" max-width="250"></v-img>
                        {{payment.description}}
                        <v-list v-if="payment.paymentMethod === 'E-transfer'">
                          <v-alert
                              dense
                              text
                              type="success"
                              v-model="emailCopied"
                          >
                            Email Copied!
                          </v-alert>
                          <v-btn class="mb-3 blue--text" @click="copyEmail" block outlined>Copy email</v-btn>
<!--                          <v-btn class="mb-6 green&#45;&#45;text" @click="sendConfirmationText" block outlined>confirm transfer</v-btn>-->
                        </v-list>
                        <v-list v-if="payment.paymentMethod === 'Credit'">
                          <v-btn class="mb-3 blue white--text" @click="routeToCardProcessing" block>Pay by card</v-btn>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <v-list v-else>
                    <v-list-item>
                      <v-img contain :src="orderData.paymentMethods[0].thumbNailImg" max-height="75" max-width="150"></v-img>
                      <v-list-item-content>
                        <v-list-item-title>{{orderData.paymentMethods[0].paymentMethod}}</v-list-item-title>
                      </v-list-item-content>

                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        {{orderData.paymentMethods[0].description}}
                      </v-list-item-content>
                    </v-list-item>
                    <v-list v-if="orderData.paymentMethods[0].paymentMethod === 'E-transfer'">
                      <v-alert
                          dense
                          text
                          type="success"
                          v-model="emailCopied"
                      >
                        Email Copied!
                      </v-alert>
                      <v-btn class="mb-3 blue--text" @click="copyEmail" block outlined>Copy email</v-btn>
<!--                      <v-btn class="mb-6 green&#45;&#45;text" @click="sendConfirmationText" block outlined>confirm transfer</v-btn>-->
                    </v-list>
                    <v-list v-if="orderData.paymentMethods[0].paymentMethod === 'Credit'">
                      <v-btn class="mb-3 blue--text" @click="routeToCardProcessing" block outlined>Add payment card</v-btn>
                    </v-list>
                  </v-list>

                </v-row>
              </v-card-text>
              <v-card-text class="mb-12">
                <div class="mt-6"> <v-icon>share</v-icon>Share invoice</div>
                <qrcode-vue :value="qrCodeLink" size="100" level="H" />
                  <a :href="qrCodeLink" style="font-size: 0.8em;">{{qrCodeLink}}</a>
              </v-card-text>

              <v-card-text v-if="orderData.toc" class="text-sm-caption font-weight-bold">
                <v-divider></v-divider>
                {{orderData.toc.substring(0,100)}}
                <span @click="tocDialog = true" class="font-weight-bold">.... read more.</span>
              </v-card-text>
            </v-card>
        </v-flex>
      </v-layout>
<!--      <v-dialog v-model="confirmTrnasferDialog"-->
<!--                persistent-->
<!--                max-width="500"-->
<!--      >-->
<!--        <v-card v-if="orderData">-->
<!--          <v-card-title>-->
<!--            Text to {{orderData.userPhoneNumber.substr(2)}}-->
<!--          </v-card-title>-->
<!--          <v-card-text>-->
<!--            <v-alert-->
<!--                dense-->
<!--                text-->
<!--                type="success"-->
<!--                v-model="textCopied"-->
<!--            >-->
<!--              Text Copied!-->
<!--            </v-alert>-->
<!--            <v-text-field-->
<!--                v-model="confirmationText"-->
<!--            >-->
<!--            </v-text-field>-->
<!--          </v-card-text>-->
<!--          <v-card-actions>-->
<!--            <v-spacer></v-spacer>-->
<!--            <v-btn class="dark" @click="confirmTrnasferDialog = false" text>close</v-btn>-->
<!--            <v-btn class="blue&#45;&#45;text" dark outlined @click="copyText()">Copy text</v-btn>-->
<!--          </v-card-actions>-->
<!--        </v-card>-->
<!--      </v-dialog>-->
      <v-dialog v-model="tocDialog"
                persistent
                max-width="500"
      >
        <v-card v-if="orderData">
          <v-card-title>
            Terms of Service
          </v-card-title>
          <v-card-text v-if="orderData.toc">
           {{toc}}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dark" @click="tocDialog = false" text>close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>
<script>
import moment from 'moment'
import QrcodeVue from 'qrcode.vue'
import { doc, onSnapshot} from "firebase/firestore";
export default {
  props: ['publicListingId', 'invoiceId'],
  components: {
    QrcodeVue,
  },
  data() {
    return {
      orderData: undefined,
      emailCopied: false,
      confirmTrnasferDialog: false,
      tocDialog: false,
      textCopied: false,
     }
  },
  created () {
    //this.$store.dispatch('setLoading', true)
    // console.log(this.listingId)
    // console.log(this.invoiceId)
    let db = this.$store.state.db
    let invoiceRef = doc(db, 'publicListings', this.publicListingId, 'invoices', this.invoiceId)
    onSnapshot(invoiceRef, res => {
      if (res.exists) {
        this.orderData = res.data()
        console.log(res.data())
        this.$store.dispatch('setLoading', false)
      }
    })
  },
  computed: {
    qrCodeLink () {
      let link
      if (this.orderData) {
        link = 'https://order.flexline.app/' + this.publicListingId + '/invoice/' + this.invoiceId
      }
      return link
    },
    // confirmationText () {
    //   let text
    //   if (this.orderData) {
    //     text = 'Transfer made for order#' + this.orderData.invoiceNumber
    //   }
    //   return text
    // },
    momentTime () {
      return (time) => {
        return moment(time, "HH:mm").format('hh:mm A')
      }
    },
    momentDate () {
      return (date) => {
        let day = moment(date, 'YYYY-MM-DD').format('dddd, MMMM Do')
        return day
      }
    },
    transactionTime () {
      return (date) => {
        let timeStamp = moment(date).format('ddd, MMM Do YYYY, hh:mm A')
        return timeStamp
      }
    },
  },
  methods: {
    copyEmail () {
      navigator.clipboard.writeText(this.orderData.userEmail)
      this.emailCopied = true
      console.log('email copied')
    },
    copyText () {
      navigator.clipboard.writeText(this.confirmationText)
      this.textCopied = true
      console.log('textCopied')
    },
    // sendConfirmationText () {
    //   console.log(this.$browserDetect)
    //   if (!this.$browserDetect.isIOS) {
    //     window.location.href = 'sms://' + this.orderData.userPhoneNumber + '/?body=' + 'E-transfer sent. Order#:' + this.orderData.invoiceNumber
    //   } else {
    //     window.location.href = 'sms://' + this.orderData.userPhoneNumber + '/&body=' + 'E-transfer sent. Order#:' + this.orderData.invoiceNumber
    //   }
    //   this.confirmTrnasferDialog = true
    // },
    routeToCardProcessing () {
      let paymentObj = {
        invoiceObj: this.orderData,
        invoiceId: this.invoiceId,
        paymentInfo: this.orderData.dueNowObj,
        transactionTime: this.transactionTime(Date.now()),
        notificationMethods: {
          email: true
        },
      }
      this.$store.dispatch('initCardPayment', paymentObj)
      //path: '/checkSmsAuth/:publicListingId/:routeTo/:routeType/:orderId',
      return this.$router.push(
          '/checkSmsAuth/'
          + this.publicListingId
          + '/stripePayment'
          + '/makePayment/'
          + this.invoiceId
      )
    }
  }
}
</script>
